export const PARTICIPANTS_FETCHING = "PARTICIPANTS_FETCHING";
export const PARTICIPANTS_FETCHED = "PARTICIPANTS_FETCHED";
export const PARTICIPANTS_FAILED = "PARTICIPANTS_FAILED";
